import { atom } from 'recoil'

export const contractorsState = atom({
    key: 'contractorsState',
    default: { summary: {}, contractors: [] }
})
